import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
          <p  className="home-about-body">
            hello i'm <span className="green"><strong>gradual</strong></span>! i program by day, build little projects by night.<br/> 
            
            <span className="green"><strong>data analysis</strong></span> and <span className="green"><strong>coding</strong></span> are hobbies that i enjoy. i also have a bias for my enstars ship subanatsuhokke.<br/><br/>
            <span className="green"><strong>just a note</strong></span>, i'm a pretty busy person so there may be times my posts might be late. <span className="green"><strong>also, please do NOT ask me how i retrieved these files! i will NOT answer your question.</strong></span><br/> <br/> <span className="green"><em><strong>it is to my digression if an asset drive has to be taken down, then i will temporarily lock and take it down.</strong></em></span>
            </p>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;

